import { supabase } from '@/lib/supabase'

export type RevshareMonthlySummaryRow = {
  competence_month: string
  payment_date: string | null
  pool_cap_bps: number
  user_share_bps: number
  revenue_net_cents: number
  pool_cents: number
  pending_cents: number
  available_cents: number
  reserved_cents: number
  paid_cents: number
  total_cents: number
  payout_id: string | null
  payout_status: string | null
  payout_scheduled_for: string | null
  payout_paid_at: string | null
}

export type RevshareMasterMonthSummary = {
  competence_month: string
  pool_cap_bps: number
  revenue_net_cents: number
  pool_cents: number
  shares_allocated_bps: number
  participants_active_count: number
  total_commissions_cents: number
  total_paid_cents: number
  total_pending_cents: number
  total_available_cents: number
  total_reserved_cents: number
}

export type RevshareMonthConfig = {
  competence_month: string
  pool_cap_bps: number
  payment_date: string | null
}

export async function getRevshareUserMonthlySummary(
  userId: string,
  months = 12,
): Promise<RevshareMonthlySummaryRow[]> {
  const { data, error } = await supabase.rpc('revshare_user_monthly_summary_v1', {
    p_user_id: userId,
    p_months: months,
  })
  if (error) throw error
  return (data as any) || []
}

export async function getRevshareMasterMonthSummary(
  monthStartDate: string,
): Promise<RevshareMasterMonthSummary> {
  const { data, error } = await supabase.rpc('revshare_master_month_summary_v1', { p_month: monthStartDate })
  if (error) throw error
  return (data as any) as RevshareMasterMonthSummary
}

export async function getRevshareMonthConfig(monthStartDate: string): Promise<RevshareMonthConfig | null> {
  const { data, error } = await supabase
    .from('revshare_month_configs')
    .select('competence_month, pool_cap_bps, payment_date')
    .eq('competence_month', monthStartDate)
    .maybeSingle()
  if (error && !String((error as any)?.message || '').includes('No rows')) throw error
  return (data as any) || null
}

export async function upsertRevshareMonthConfig(cfg: RevshareMonthConfig): Promise<void> {
  const payload = {
    competence_month: cfg.competence_month,
    pool_cap_bps: Math.max(0, Math.min(10000, Math.round(Number(cfg.pool_cap_bps || 0)))),
    payment_date: cfg.payment_date || null,
  }
  const { error } = await supabase.from('revshare_month_configs').upsert(payload, { onConflict: 'competence_month' })
  if (error) throw error
}

